// @ts-nocheck
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { FormTemplateService } from '../../dynamic-form/sub-modules/form-template/form-template.service';
import { InputTextComponent } from '../input-text/input-text.component';
import { InputReferenceService } from './input-reference.service';

@Component({
  selector: 'legalboxplus-input-reference',
  templateUrl: './input-reference.component.html',
  imports: [InputTextComponent],
})
export class InputReferenceComponent implements OnInit, OnDestroy {
  private inputService = inject(InputReferenceService);
  private formService = inject(FormTemplateService);
  private dynamicFormService = inject(DynamicFormService);

  ngOnInit(): void {
    if (this.fieldProps?.entityKey && this.fieldProps?.childrenDependency) {
      window.addEventListener(`reload_${this.fieldProps.entityKey}`, this.listener, false);
    }
  }
  private _entityValue = '';

  public get entityValue() {
    return this._entityValue;
  }

  public set entityValue(value) {
    this._entityValue = value;
  }

  public labelValue = '';
  public idReference: any = [''];
  public fieldProps: any = null;
  public cardInfo!: any;

  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set field(value: any) {
    this.fieldProps = value;
  }
  @Input() set cardData(data) {
    this.cardInfo = data;
  }
  @Input() set value(value: any) {
    if (value) {
      this.valueHandler(value);
    }
  }

  private getDataByArtifactInfo(value: any) {
    // setTimeout(() => {
    // busca lib simples
    const params: any = { id: value };
    if (this.fieldProps.valueRecoverUrl) {
      if (this.fieldProps.monetary) {
        (params.code = 'USD'), (params.codein = 'BRL'), (params.value = value);
      }

      if (this.fieldProps.auxEntity) {
        const { filter, tableName } = this.fieldProps.auxEntity;
        const filters = { [filter]: value };
        (params.tableName = tableName), (params.filters = JSON.stringify(filters));
      }

      if (this.fieldProps?.params) {
        const keyList = this.fieldProps.params;
        keyList.forEach((prop: string) => {
          if ((this.dynamicFormService?.formControlStructure?.fieldControl as any)?.[prop]) {
            params[prop] = (this.dynamicFormService?.formControlStructure?.fieldControl as any)[
              prop
            ].value;
          }
        });
      }

      this.inputService
        .getDinamicUrl(this.fieldProps.valueRecoverUrl, params)
        .subscribe((resp: any) => {
          if ((!Array.isArray(resp) && this.fieldProps.monetary) || this.fieldProps?.params) {
            this.entityValue =
              typeof resp === 'number'
                ? String(resp.toFixed(2))
                : (resp as any)[this.fieldProps.entityKey].toFixed(2);
          } else if (!Array.isArray(resp)) {
            this.entityValue = resp[this.fieldProps?.recoverKey ?? 'label'];
          } else {
            this.entityValue = resp[0][this.fieldProps?.recoverKey ?? 'label'];
          }
          this.entityValue = this.entityValue ?? '';
        });
      // busca de artefato
    } else if (!this.fieldProps.index) {
      this.inputService
        .getDinamicUrl(this.fieldProps.entitySelectedRecoverUrl, {
          ids: JSON.stringify(value),
          returnFields: [this.fieldProps.entityColumnName],
        })
        .subscribe((resp: any) => {
          const entity = resp ? resp[0] : null;
          this.entityValue = entity[this.fieldProps.entityColumnName];

          if (entity) {
            if (this.fieldProps.auxEntity) {
              const { entityUrl, tableName } = this.fieldProps.auxEntity;
              if (entityUrl && tableName) {
                this.formService
                  .getDinamicUrl<any[]>(entityUrl, { tableName, flowId: this.cardInfo.flowId })
                  .subscribe((data: any[]) => {
                    this.entityValue =
                      data.find((i) => i.id === this.entityValue)?.label ?? this.entityValue;
                  });
              }
            }
          }
        });
    } else {
      // busca de people
      const { data, primary } = value;
      const params = {
        ids: JSON.stringify(data),
        returnFields: JSON.stringify([this.fieldProps.entityColumnName]),
        index: this.fieldProps.index,
      };
      this.inputService
        .getDinamicUrl(this.fieldProps.entitySelectedRecoverUrl, params)
        .subscribe((resp: any) => {
          const entity = resp?.[0];
          if (entity) {
            this.entityValue = entity[this.fieldProps.entityColumnName];
          }
        });
    }
    // }, 100)
  }

  listener = (e: any) => {
    if (e.detail?.entityRecoverKey_value) {
      this.valueHandler(e.detail.entityRecoverKey_value);
    }
  };

  valueHandler(value) {
    if (this.fieldProps.valueRecoverUrl) {
      this.idReference = value;
      this.getDataByArtifactInfo(this.idReference);
    } else if (this.fieldProps.entitySelectedRecoverUrl) {
      if (typeof value === 'string') {
        this.idReference = [value];
        this.getDataByArtifactInfo(this.idReference);
      } else {
        this.idReference = value;
        this.getDataByArtifactInfo(this.idReference);
      }
    } else {
      this.entityValue = value;
    }
  }

  ngOnDestroy() {
    window.removeEventListener(`reload_${this.fieldProps.entityKey}`, this.listener, false);
  }
}
